import { jsx as _jsx } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles(theme => ({
  button: {
    all: 'unset',
    padding: 0,
    border: 'none',
    backgroundColor: theme.palette.transparent,
    color: theme.palette.link.main,
    fontSize: `${theme.type.fontSize.bodySm}px`,
    '&:hover, &:focus': {
      cursor: 'pointer'
    },
    textDecoration: 'underline'
  }
}));
const LinkStyleButton = ({
  children,
  onClick = () => null
}) => {
  const classes = useStyles();
  return _jsx("button", {
    type: "button",
    className: classes.button,
    onClick: onClick,
    children: children
  });
};
export default LinkStyleButton;